// extracted by mini-css-extract-plugin
module.exports = {"buttonTransparent":"ButtonTransparent_buttonTransparent__2DTKz"};